import Swiper from 'swiper';
import { Autoplay, Pagination, EffectFade } from 'swiper/modules';

class HomeHeading {
  constructor() {
    this._init();
  }

  _init() {
    const swiperFull = new Swiper('.home-heading__swiper--full', {
      modules: [Autoplay, EffectFade],
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      effect: 'fade',
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });

    const swiperSmall = new Swiper('.home-heading__swiper--small', {
      modules: [Autoplay, EffectFade],
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      effect: 'fade',
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
    });
  }
}

export const homeHeading = new HomeHeading();
